import React from 'react';

import { Grid, makeStyles, Typography, useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  noteContainer: {
    paddingBottom: '60px',
    paddingTop: '1rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: 15,
      minHeight: 40,
      paddingBottom: '40px',
      paddingTop: 15,
    },
  },
}));

export default ({ notes }) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  return (
    <div className={`${isDesktop && 'top-separator'} w-100 ${classes.noteContainer}`}>
      <Grid container>
        <Grid item xs={12}>
          <Typography align="left" style={{ color: '#475C7E', fontSize: '14px', lineHeight: '21px', marginBottom: '0px' }}>
            {notes}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};
